import { Card, CardContent } from "../../ui/card";
import { Sparkline } from "./Sparkline";

const COLOR_MAP = {
  cyan: "border-cyan-200 dark:border-cyan-800/40 bg-cyan-50/50 dark:bg-cyan-950/10 text-cyan-800 dark:text-cyan-300",
  emerald: "border-emerald-200 dark:border-emerald-800/40 bg-emerald-50/50 dark:bg-emerald-950/10 text-emerald-800 dark:text-emerald-300",
  red: "border-red-200 dark:border-red-800/40 bg-red-50/50 dark:bg-red-950/10 text-red-800 dark:text-red-300",
  amber: "border-amber-200 dark:border-amber-800/40 bg-amber-50/50 dark:bg-amber-950/10 text-amber-800 dark:text-amber-300",
  slate: "border-border bg-card text-foreground",
};
const STROKE_MAP = {
  cyan: "#0891b2", emerald: "#059669", red: "#dc2626", amber: "#d97706", slate: "#64748b",
};

export function KpiCard({
  icon, label, value, sub, color = "slate",
  sparkline, trendRange, onTrendRangeChange, sparklineMode = "line",
}) {
  const stroke = STROKE_MAP[color] || "#64748b";
  const hasToggle = typeof onTrendRangeChange === "function";
  return (
    <Card className={`border ${COLOR_MAP[color]} shadow-sm`}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 text-[11px] uppercase tracking-wider min-w-0">
            {icon}
            <span className="truncate">{label}</span>
          </div>
          {hasToggle && (
            <div className="flex items-center rounded-md border bg-background/60 text-[10px] font-medium overflow-hidden" data-testid="kpi-trend-toggle">
              {["7d", "30d"].map((r) => (
                <button
                  key={r}
                  type="button"
                  onClick={() => onTrendRangeChange(r)}
                  className={`px-1.5 py-0.5 transition-colors ${trendRange === r ? "bg-foreground/10 text-foreground" : "text-muted-foreground hover:text-foreground"}`}
                  data-testid={`kpi-trend-${r}`}
                >
                  {r.toUpperCase()}
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="flex items-end justify-between gap-2 mt-1.5">
          <div className="min-w-0">
            <p className="text-2xl font-bold text-foreground truncate">{value}</p>
            {sub && <p className="text-[11px] text-muted-foreground mt-0.5">{sub}</p>}
          </div>
          {sparkline && sparkline.length >= 2 && (
            <Sparkline points={sparkline} stroke={stroke} wide={sparkline.length > 10} mode={sparklineMode} />
          )}
        </div>
      </CardContent>
    </Card>
  );
}
